import React, { Ref } from 'react';
import ClearAllButtonContainer from '../../../clear-all-button-container';
import ItemCountContainer from '../../../item-count-container';
import RailSection from '../../../rail-section';
import LeftHandFacets from '../../../left-hand-facets';
import DivisionNav from '../../../division-nav';
import BopisBarFragment from '../../../bopis-bar-fragment';
import getItemCountAndClearAllCombinedStyles from './styles';

const DesktopExperience = (
  itemCountAndClearButtonRef: Ref<HTMLDivElement>,
  appliedFacetsCount: number,
): JSX.Element[] => [
  <RailSection position="scrollable" key="rail-section__left-nav">
    <DivisionNav />
  </RailSection>,
  <RailSection position="scrollable" key="rail-section__sticky-filter-details">
    <div
      key="sticky-filter-details"
      ref={itemCountAndClearButtonRef}
      css={getItemCountAndClearAllCombinedStyles}
    >
      <ItemCountContainer />
      { appliedFacetsCount > 0 && <ClearAllButtonContainer />}
    </div>
    <BopisBarFragment position="null" />
    <LeftHandFacets />
  </RailSection>,
];

export default DesktopExperience;
